import * as DomainPageConstants from '../../action/domainPage/DomainPageConstants';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  hasError: false,
  success: false,
  whoIsData: null,

  allDomainsData: [],
  allDomainsDataIsFetching: false,
  allDomainsDataErrorMessage: '',

  checkReservedDomainsIdsData: [],
  checkReservedDomainsIdsDataIsFetching: false,
  checkReservedDomainsIdsDataErrorMessage: '',

  domainImagesCountData: { count: 0 },
  domainImagesCountDataIsFetching: false,
  domainImagesCountDataErrorMessage: '',

  saveDomainData: {},
  saveDomainDataIsFetching: false,
  saveDomainDataErrorMessage: '',

  domainsWorkData: []
};

export const domainsStore = (state = initialState, action) => {
  switch (action.type) {
    case DomainPageConstants.GET_THIRD_PARTY_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };

    case DomainPageConstants.GET_THIRD_PARTY_DATA_ERROR:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        success: false
      };

    case DomainPageConstants.GET_THIRD_PARTY_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        success: true,
        whoIsData: action.data
      };

    case DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_REQUEST:
      return {
        ...state,
        allDomainsDataIsFetching: true,
        allDomainsDataErrorMessage: ''
      };
    case DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_SUCCESS:
      let newAllDomainsData = _.concat([], state.allDomainsData, action.data);
      let newReservedDomainsIds = _.concat(
        [],
        state.reservedDomainsIds,
        action.data
      );
      return {
        ...state,
        allDomainsDataIsFetching: false,
        allDomainsData: newAllDomainsData,
        reservedDomainsIds: newReservedDomainsIds,
        allDomainsDataErrorMessage: ''
      };
    case DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_FAILED:
      return {
        ...state,
        allDomainsDataIsFetching: false,
        allDomainsDataErrorMessage: 'SERVER ERROR'
      };
    case DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_CLEAR:
      return {
        ...state,
        allDomainsDataIsFetching: false,
        allDomainsData: [],
        allDomainsDataErrorMessage: ''
      };

    case DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_REQUEST:
      return {
        ...state,
        checkReservedDomainsIdsDataIsFetching: true,
        checkReservedDomainsIdsDataErrorMessage: ''
      };
    case DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_SUCCESS:
      return {
        ...state,
        checkReservedDomainsIdsDataIsFetching: false,
        checkReservedDomainsIdsData: action.data
      };
    case DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_FAILED:
      return {
        ...state,
        checkReservedDomainsIdsDataIsFetching: false,
        checkReservedDomainsIdsDataErrorMessage: 'SERVER ERROR'
      };
    case DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_CLEAR:
      return {
        ...state,
        checkReservedDomainsIdsDataIsFetching: false,
        checkReservedDomainsIdsData: [],
        checkReservedDomainsIdsDataErrorMessage: ''
      };

    case DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_REQUEST:
      return {
        ...state,
        domainImagesCountData: { count: 0 },
        domainImagesCountDataIsFetching: true,
        domainImagesCountDataErrorMessage: ''
      };
    case DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_SUCCESS:
      return {
        ...state,
        domainImagesCountDataIsFetching: false,
        domainImagesCountData: action.data
      };
    case DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_FAILED:
      return {
        ...state,
        domainImagesCountDataIsFetching: false,
        domainImagesCountData: { count: 0 },
        domainImagesCountDataErrorMessage: 'SERVER ERROR'
      };
    case DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_CLEAR:
      return {
        ...state,
        domainImagesCountDataIsFetching: false,
        domainImagesCountData: { count: 0 },
        domainImagesCountDataErrorMessage: ''
      };

    case DomainPageConstants.SAVE_DOMAIN_DATA_REQUEST:
      return {
        ...state,
        saveDomainDataIsFetching: true,
        saveDomainDataErrorMessage: ''
      };
    case DomainPageConstants.SAVE_DOMAIN_DATA_SUCCESS:
      return {
        ...state,
        saveDomainDataIsFetching: false,
        saveDomainData: action.data
      };
    case DomainPageConstants.SAVE_DOMAIN_DATA_FAILED:
      return {
        ...state,
        saveDomainDataIsFetching: false,
        saveDomainDataErrorMessage: 'SERVER ERROR'
      };
    case DomainPageConstants.SAVE_DOMAIN_DATA_CLEAR:
      return {
        ...state,
        saveDomainDataIsFetching: false,
        saveDomainData: {},
        saveDomainDataErrorMessage: ''
      };
    case DomainPageConstants.CHANGE_DOMAINS_WORK_DATA:
      let newDomainWorkData = _.cloneDeep(state.domainsWorkData);

      if (action.deleteIndex !== null) {
        // delete newDomainWorkData[action.deleteIndex]
        // newDomainWorkData = _.merge({}, newDomainWorkData, action.data)
        // newDomainWorkData.splice(action.deleteIndex, 1)
        newDomainWorkData[action.deleteIndex] = action.data;
      } else {
        // newDomainWorkData = _.merge({}, newDomainWorkData, action.data)
        newDomainWorkData.push(action.data);
      }

      return {
        ...state,
        domainsWorkData: newDomainWorkData
      };
    default:
      return state;
  }
};
